import axios from "axios";

export const getStatiKpiApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/stati_kpi/`);
}

export const getStatoKpiByIdApi = (idStato) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/stati_kpi/${idStato}`);
}

export const aggiornaStatoKpiApi = (idStato, stato) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/stati_kpi/${idStato}`, stato);
}